import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "entitySelect",
    "entitySelectContainer",
    "featurableId",
    "organizationSelect",
    "submit",
    "typeSelect",
    "acknowledge",
    "platformSelectContainer",
    "platformCheckbox"
  ]

  connect() {
    $(this.context.element).on("show.bs.modal", () => {
      this.initializeSelect2()
      this.registerListeners()
      this.setSubmitState()
    })

    $(this.context.element).on("hidden.bs.modal", () => {
      this.removeSelect2()
      this.removeListeners()
    })
  }

  entityAjaxData(params) {
    return { term: params.term, page: params.page, organization_id: this.organizationId }
  }

  clearEntitySelection() {
    $(this.entitySelectTarget).val(null).trigger("change")
  }

  fieldValid(val) {
    return val && val.length > 0
  }

  initializeSelect2() {
    $(this.typeSelectTarget).select2({
      placeholder: "Select an exclusion type...",
      theme: "bootstrap",
      allowClear: true,
      width: "100%",
    })

    $(this.organizationSelectTarget).select2({
      placeholder: "Select an organization...",
      theme: "bootstrap",
      allowClear: true,
      width: "100%",
    })

    const placeholder = this.entitySelectTarget.dataset.placeholder
    const url = this.entitySelectTarget.dataset.url
    $(this.entitySelectTarget).select2({
      placeholder: placeholder,
      theme: "bootstrap",
      allowClear: true,
      width: "100%",
      cache: true,
      ajax: {
        url: url,
        dataType: "json",
        data: this.entityAjaxData.bind(this),
        delay: 150,
      },
    })
  }

  removeSelect2() {
    $(this.typeSelectTarget).select2("destroy")
    $(this.organizationSelectTarget).select2("destroy")
    $(this.entitySelectTarget).select2("destroy")
  }


  onEntitySelect() {
    if (this.isExclusionTypeEntity) {
      this.featurableIdTarget.setAttribute("value", this.entityId)
    }
    this.setSubmitState()
  }

  onOrganizationSelect() {
    if (this.exclusionType === "Organization") {
      this.featurableIdTarget.setAttribute("value", this.organizationId)
    }
    this.clearEntitySelection()
    this.setSubmitState()
  }

  onTypeSelect() {
    if (this.exclusionType === "Organization") {
      this.entitySelectContainerTarget.classList.add("hidden")
      this.showPlatformSelect = true

      this.onOrganizationSelect()
    } else {
      this.entitySelectContainerTarget.classList.remove("hidden")
      this.showPlatformSelect = false

      this.setSubmitState()
    }
  }

  onAcknowledgeChecked() {
    this.setSubmitState()
  }

  registerListeners() {
    $(this.entitySelectTarget).on("select2:select select2:clear", this.onEntitySelect.bind(this))
    $(this.organizationSelectTarget).on("select2:select select2:clear", this.onOrganizationSelect.bind(this))
    $(this.typeSelectTarget).on("select2:select select2:clear", this.onTypeSelect.bind(this))
    if (this.hasAcknowledgeTarget) {
      $(this.acknowledgeTarget).on("change", this.onAcknowledgeChecked.bind(this))
    }

    if (this.hasPlatformSelectContainerTarget) {
      this.platformCheckboxTargets.forEach(cb => {
        cb.addEventListener("change", _ => { this.setSubmitState() })
      })
    }
  }

  removeListeners() {
    $(this.entitySelectTarget).off("select2:select select2:clear")
    $(this.organizationSelectTarget).off("select2:select select2:clear")
    $(this.typeSelectTarget).off("select2:select select2:clear")
  }

  setSubmitState() {
    if (this.formValid) {
      this.submitTarget.disabled = false
    } else {
      this.submitTarget.disabled = true
    }
  }

  get entityId() {
    let selectedData = $(this.entitySelectTarget).select2("data")
    return selectedData.length > 0 ? selectedData[0].id : null
  }

  get exclusionType() {
    let selectedData = $(this.typeSelectTarget).select2("data")
    return selectedData.length > 0 ? selectedData[0].id : null
  }

  get formValid() {
    if (this.hasAcknowledgeTarget && !this.acknowledgeTarget.checked) {
      return false
    }

    if (this.exclusionType === "Organization") {
      return this.isPlatformSelectionValid && this.fieldValid(this.organizationId)
    } else if (this.isExclusionTypeEntity) {
      return this.fieldValid(this.organizationId) && this.fieldValid(this.entityId)
    } else {
      return false
    }
  }

  get organizationId() {
    let selectedData = $(this.organizationSelectTarget).select2("data")
    return selectedData.length > 0 ? selectedData[0].id : null
  }

  get isExclusionTypeEntity() {
    return this.exclusionType === "Agent" || this.exclusionType === "Identity"
  }

  get allowPlatformSelect() {
    return this.hasPlatformSelectContainerTarget
  }

  set showPlatformSelect(shouldShow) {
    if (!this.allowPlatformSelect) {
      return
    }

    if (shouldShow) {
      this.platformSelectContainerTarget.classList.remove("hidden")
    } else {
      this.platformSelectContainerTarget.classList.add("hidden")
    }
  }

  get isPlatformSelectionValid() {
    return !this.allowPlatformSelect || this.platformCheckboxTargets.some(cb => cb.checked)
  }
}
